; var __browserify_shim_require__=require;(function browserifyShim(module, exports, require, define, browserify_shim__define__module__export__) {
function InvalidFilterError(message) {
	this.message = message;
}

InvalidFilterError.prototype = new Error();

; browserify_shim__define__module__export__(typeof InvalidFilterError != "undefined" ? InvalidFilterError : window.InvalidFilterError);

}).call(global, undefined, undefined, undefined, undefined, function defineExport(ex) { module.exports = ex; });
